import { classnames } from '@aibees/shared/utils';
import { TabContext, TabList } from '@mui/lab';
import { Card, Stack, Tab } from '@mui/material';
import React, { memo, useState } from 'react';
import { users } from '../../mockData';
import { StatusType } from '../../types';
import { InformationCard } from '../information-card';
import { TabLabel } from './components/tab-label';
import * as Styled from './styles';
import * as SX from './sx';
import { UsersStatus, type UsersTabProps as Props } from './types';

const TAB_CONFIG = [
  { status: UsersStatus.TOTAL, title: 'Total' },
  { status: UsersStatus.ACTIVE, title: 'Active' },
  { status: UsersStatus.DEACTIVATE, title: 'Deactivate' },
  { status: UsersStatus.PENDING, title: 'Pending' },
] as const;

export const UsersTab = memo(({ className }: Props) => {
  const [tabValue, setTabValue] = useState(UsersStatus.TOTAL);

  const handleChangeTab = (
    event: React.SyntheticEvent,
    newValue: UsersStatus
  ) => {
    setTabValue(newValue);
  };

  const renderItems = () => {
    if (tabValue === UsersStatus.TOTAL) return users;
    return users.filter(
      (i) => i.status === (tabValue as unknown as StatusType)
    );
  };

  return (
    <>
      <TabContext value={tabValue}>
        <TabList onChange={handleChangeTab} variant="fullWidth" sx={SX.tabList}>
          {TAB_CONFIG.map(({ status, title }) => {
            const count =
              status === UsersStatus.TOTAL
                ? users.length
                : users.filter((u) => u.status === status).length;

            return (
              <Tab
                key={status}
                value={status}
                label={
                  <TabLabel
                    title={title}
                    count={count}
                    active={tabValue === status}
                  />
                }
              />
            );
          })}
        </TabList>
      </TabContext>
      <Styled.Wrapper
        className={classnames('UsersTab', className)}
        sx={SX.root}
        gap={1}
      >
        <Stack gap={2}>
          {renderItems().map((i) => (
            <Card variant="outlined" key={i.name}>
              <InformationCard data={i} isUserCard />
            </Card>
          ))}
        </Stack>
      </Styled.Wrapper>
    </>
  );
});

UsersTab.displayName = 'UsersTab';
